import {
  IconVisa,
  IconMastercard,
  IconAmex,
  IconMaestro,
  IconDinersClub,
  IconCard as IconCard,
  IconCard as IconIKO,
  IconCard as IconSavvy,
  IconUnionPay,
  IconJCB,
} from "@/icons"
import type { Component } from "vue"

const SUPPORTED_CARD_SCHEMES = [
  "visa",
  "mastercard",
  "amex",
  "americanexpress",
  "iko",
  "savvy",
  "unionpay",
  "dinersclub",
  "maestro",
  "jcb",
  "unknown",
] as const

const iconMap: Record<
  (typeof SUPPORTED_CARD_SCHEMES)[number],
  Component
> = {
  visa: IconVisa,
  mastercard: IconMastercard,
  amex: IconAmex,
  americanexpress: IconAmex,
  iko: IconIKO,
  savvy: IconSavvy,
  unionpay: IconUnionPay,
  dinersclub: IconDinersClub,
  maestro: IconMaestro,
  jcb: IconJCB,
  unknown: IconCard,
}

export const getCardSchemeIcon = (
  cardScheme: string | null
): Component => {
  const normalizedCardScheme = (cardScheme ?? "unknown")
    .toLowerCase()
    .replace(" ", "")
    .replace("_", "")

  const closestSupportedScheme =
    SUPPORTED_CARD_SCHEMES.find((supportedScheme) =>
      supportedScheme.includes(normalizedCardScheme)
    ) ?? "unknown"

  return iconMap[closestSupportedScheme]
}
